/** Display helpers for the green Notifications tab (batch inbox). */

export function batchInboxInitials(item) {
  const label = item?.recipe_name || item?.operation_name || item?.batch_number || '?';
  return String(label)
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0])
    .join('')
    .slice(0, 4)
    .toUpperCase();
}

export function formatOperationLabel(item) {
  const name = item?.operation_name || '';
  const num = item?.operation_number;
  if (name && num != null && num !== '') return `#${num} ${name}`;
  if (name) return name;
  if (num != null && num !== '') return `Operation #${num}`;
  return '';
}
